import Auth from "j-toker";
import { authUrl2 } from "./api/Constants";
require("dotenv").config();

Auth.configure({
  apiUrl: authUrl2,
  tokenValidationPath: "/auth/validate_token",
});

export const signin = (values) => Auth.emailSignIn(values);

export const validate_token = () => {
  return Auth.validateToken();
};

export const signUp = (values) => Auth.emailSignUp(values);
